<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{ 'Turbo.CreditInvoiceDialog.HeadLine' | translate:'Credit Amount' : null : 'Title for credit amount.' }}" [isLoading]="isLoading">
    @for(invoiceLine of invoiceLines; track invoiceLine.ProductId) {
    <div class="row">
      <div class="col-4" style="margin-top: 5px; white-space: nowrap; align-content: center;">{{ invoiceLine.ProductName }}: </div>
      <div class="col-5" style="margin-top: 5px; white-space: nowrap">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>{{ 'Turbo.CreditInvoiceDialog.txtAmount' | translate : 'Amount' : null : 'Credit amount dialog -  label amount'}}</mat-label>
          <input type="number" required matInput [(ngModel)]="invoiceLine.CreditAmount">
        </mat-form-field>
      </div>
      <div class="col-3" style="margin-top: 5px; white-space: nowrap; align-content: center;">{{ 'Turbo.CreditInvoiceDialog.txtAmountMaxLimit' | translate : 'Max limit' : null : 'Credit amount dialog -  label Maximum limit'}}: {{ (invoiceLine.Price - invoiceLine.CreditedAmount) | number:'1.2-2' }}</div>
    </div>
      }
      <div class="row">
        <div class="col-12" style="margin-top: 5px; white-space: nowrap">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ 'Turbo.CreditInvoiceDialog.txtComment' | translate : 'Comment' : null : 'Credit amount dialog - label comment'}}</mat-label>
            <textarea matInput [(ngModel)]="comment" placeholder="{{ 'Turbo.CreditInvoiceDialog.plComment' | translate : 'Please provide a credit comment.' :  null : 'Credit amount dialog - please provide credit amount' }}" matTextareaAutosize matAutosizeMinRows="6" matAutosizeMaxRows="6"></textarea>
          </mat-form-field>
        </div>
      </div>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" style="margin: 5px;" [disabled]="isLoading" (click)="creditAmount()">{{ 'Turbo.CreditInvoiceDialog.cmdCredit' | translate : 'Credit' : null :  'Credit amount dialog - button credit'}}</button>
</mat-dialog-actions>
